// export this package's api
import Cascader from './Cascader';

export default Cascader;


//////////////////
// WEBPACK FOOTER
// ./~/rc-cascader/es/index.js
// module id = 1450
// module chunks = 3